import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { AuthCheckService } from '../services/auth-check.service';
import { ConfigService } from '../services/config.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authCheckService: AuthCheckService,
    private configService: ConfigService
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Only the Skye API gets the token. The OIDC library's own requests also pass through here,
    // and checkAuth depends on them, so they must not wait for it.
    if (!req.url.startsWith(`${this.configService.config.apiUrl}/api`)) {
      return next.handle(req);
    }

    return this.authCheckService.getAccessToken().pipe(
      switchMap(token => {
        if (token) {
          req = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
        }
        return next.handle(req);
      })
    );
  }
}
